import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, ButtonProps } from '@mui/material';

export const ExternalLinkButton: React.FC<ButtonProps<'a'>> = ({ children, sx, ...props }) => (
  <Button
    component="a"
    rel="noopener noreferrer"
    target="_blank"
    variant="outlined"
    endIcon={<OpenInNewIcon />}
    sx={{ height: 'fit-content', ...sx }}
    {...props}
  >
    {children}
  </Button>
);
